export type ServiceManufacturingFaqConfig = {
	namespace: string;
	faqCount: number;
	titleKey: string;
	moreKey: string;
	keyPrefix: string;
};

export const SERVICE_MANUFACTURING_FAQ_CONFIG: Record<string, ServiceManufacturingFaqConfig> = {
	stamping: {
		namespace: "new-stamping",
		faqCount: 9,
		titleKey: "faqsTitle",
		moreKey: "faqsSeeMoreFAQs",
		keyPrefix: "faqs",
	},
	welding: {
		namespace: "new-welding",
		faqCount: 8,
		titleKey: "faqsTitle",
		moreKey: "faqsSeeMoreFAQs",
		keyPrefix: "faqs",
	},
	"metal-casting": {
		namespace: "new-metal-casting",
		faqCount: 8,
		titleKey: "faqsTitle",
		moreKey: "faqsSeeMoreFAQs",
		keyPrefix: "faqs",
	},
	"investment-casting": {
		namespace: "new-investment-casting",
		faqCount: 8,
		titleKey: "faqsTitle",
		moreKey: "faqsSeeMoreFAQs",
		keyPrefix: "faqs",
	},
	"high-pressure-casting": {
		namespace: "new-high-pressure-casting",
		faqCount: 10,
		titleKey: "faqsTitle",
		moreKey: "faqsSeeMoreFAQs",
		keyPrefix: "faqs",
	},
	"low-pressure-casting": {
		namespace: "new-low-pressure-casting",
		faqCount: 10,
		titleKey: "faqsTitle",
		moreKey: "faqsSeeMoreFAQs",
		keyPrefix: "faqs",
	},
	"sand-casting": {
		namespace: "new-sand-casting",
		faqCount: 9,
		titleKey: "faqsTitle",
		moreKey: "faqsSeeMoreFAQs",
		keyPrefix: "faqs",
	},
	"die-casting": {
		namespace: "new-die-casting",
		faqCount: 10,
		titleKey: "faqsTitle",
		moreKey: "faqsSeeMoreFAQs",
		keyPrefix: "faqs",
	},
	"vacuum-casting": {
		namespace: "new-vacuum-casting",
		faqCount: 9,
		titleKey: "faqsTitle",
		moreKey: "faqsSeeMoreFAQs",
		keyPrefix: "faqs",
	},
	"3d-printing": {
		namespace: "new-3d-printing",
		faqCount: 7,
		titleKey: "faqsTitle",
		moreKey: "faqsSeeMoreFAQs",
		keyPrefix: "faqs",
	},
	"aluminum-extrusion": {
		namespace: "new-aluminum-extrusion",
		faqCount: 12,
		titleKey: "faqsTitle",
		moreKey: "faqsSeeMoreFAQs",
		keyPrefix: "faqs",
	},
	"spring-manufacturing": {
		namespace: "new-spring-manufacturing",
		faqCount: 10,
		titleKey: "faqsTitle",
		moreKey: "faqsSeeMoreFAQs",
		keyPrefix: "faqs",
	},
	"surface-finishing": {
		namespace: "new-surface-finishing",
		faqCount: 6,
		titleKey: "faqsTitle",
		moreKey: "faqsSeeMoreFAQs",
		keyPrefix: "faqs",
	},
	"on-demand-manufacturing": {
		namespace: "new-on-demand-manufacturing",
		faqCount: 6,
		titleKey: "faqsTitle",
		moreKey: "faqsSeeMoreFAQs",
		keyPrefix: "faqs",
	},
	assembly: {
		namespace: "new-assembly",
		faqCount: 6,
		titleKey: "faqsTitle",
		moreKey: "faqsSeeMoreFAQs",
		keyPrefix: "faqs",
	},
	"industrial-automation": {
		namespace: "new-industrial-automation",
		faqCount: 6,
		titleKey: "faqsTitle",
		moreKey: "faqsSeeMoreFAQs",
		keyPrefix: "faqs",
	},
	"sla-stereolithography": {
		namespace: "new-sla-stereolithography",
		faqCount: 10,
		titleKey: "faqsTitle",
		moreKey: "faqsSeeMoreFAQs",
		keyPrefix: "faqs",
	},
	"sls-selective-laser-sintering": {
		namespace: "new-sls-selective-laser-sintering",
		faqCount: 9,
		titleKey: "faqsTitle",
		moreKey: "faqsSeeMoreFAQs",
		keyPrefix: "faqs",
	},
	"fdm-fused-deposition-modeling": {
		namespace: "new-fdm-fused-deposition-modeling",
		faqCount: 10,
		titleKey: "faqsTitle",
		moreKey: "faqsSeeMoreFAQs",
		keyPrefix: "faqs",
	},
	"mjf-multi-jet-fusion": {
		namespace: "new-mjf-multi-jet-fusion",
		faqCount: 9,
		titleKey: "faqsTitle",
		moreKey: "faqsSeeMoreFAQs",
		keyPrefix: "faqs",
	},
};

export const DEFAULT_MANUFACTURING_FAQ_CONFIG: ServiceManufacturingFaqConfig = {
	namespace: "manufacturingFAQs",
	faqCount: 8,
	titleKey: "title",
	moreKey: "seeMoreFAQs",
	keyPrefix: "",
};
